import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  production: true,
  apiEndpoint: 'https://start.efs-ag.com/v1',
  userApiEndpoint: 'https://api.efs-ag.services/v2',

  openIdConfig: {
    authority: 'https://auth.efs-ag.services',
    redirectUrl: 'https://start.development.ingress.efs-ag.services',
    postLogoutRedirectUri: 'https://start.development.ingress.efs-ag.services',
    clientId: 'efs.start.development',
    scope: 'openid email profile',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 180,
    logLevel: LogLevel.Error,
    forbiddenRoute: '/unauthorized',
    unauthorizedRoute: '/unauthorized',
  },
};
